<ion-header>
  <ion-toolbar mode="md"
               color="dark">
    <ion-title>{{label}}</ion-title>
    <ion-buttons slot="end">
      <ion-button mode="md"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onCloseModal()">{{ 'common.close' | transloco }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content fullscreen>
  <form [formGroup]="form"
        class="notes">
    <ion-textarea #notesInput
                  formControlName="notes"
                  [placeholder]="'pos.addNoteHere' | transloco"></ion-textarea>
  </form>
</ion-content>
<ion-footer>
  <ion-toolbar mode="md"
               color="light">
    <ion-buttons slot="end">
      <ion-button mode="md"
                  color="dark"
                  fill="solid"
                  [disabled]="form.pristine || form.invalid"
                  debounce-click
                  [debounceTime]="0"
                  (debounceClick)="onSaveNotes()">{{ 'pos.saveNotes' | transloco }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>